module.exports = __webpack_public_path__ + "static/media/alan.29ee57b5.jpeg";